import React, { Component } from "react";
import { connect } from "react-redux";
import Page from "../shared/Page";
import firebase from "firebase/app";
import PropTypes from "prop-types";
import "firebase/auth";

class DevPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			token: "",
			copied: false,
		};
		this.textAreaRef = React.createRef();
	}

	componentDidMount = () => {
		firebase
			.auth()
			.currentUser.getIdToken(true)
			.then(data => this.setState({ token: data }));
	};

	copyToClipboard = () => {
		const { token } = this.state;
		navigator.clipboard.writeText(token);
		this.setState({ copied: true });
	};

	render() {
		return (
			<Page title="Dev">
				<div style={{ wordBreak: "break-all" }}>{this.state.token}</div>
				<br />
				<div style={{ display: "flex", alignItems: "center" }}>
					<button className="btn btn-info" onClick={this.copyToClipboard}>
						Copy to clipboard
					</button>
					{this.state.copied && (
						<p style={{ marginLeft: "20px", marginBottom: "0", color: "#00c15b" }}>Copied to clipboard!</p>
					)}
				</div>
			</Page>
		);
	}
}
DevPage.propTypes = {
	match: PropTypes.object,
};
const mapStateToProps = state => ({
	experiences: state.experiences,
	apps: state.apps.apps,
	cultures: state.cultures.cultures,
});

const mapDispatchToProps = dispatch => ({});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(DevPage);
